import format from "date-fns/format";

type DateRange<Format> = { from: Format; to: Format };
export type DateRangePropertiesNullable<Format> = { from: Format | null; to: Format | null };

export const stringifyDateRange = (dateRange: DateRange<Date>) => ({
  from: format(dateRange.from, "yyyy-MM-dd"),
  to: format(dateRange.to, "yyyy-MM-dd"),
});

export const nullifyEmptyDateRange = (dateRange: DateRangePropertiesNullable<Date>): DateRange<Date> | null => {
  const { from, to } = dateRange;
  return from && to ? (dateRange as DateRange<Date>) : null;
};

export default DateRange;
